const e = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true"><path fill-rule="evenodd" d="M12 4.5a2.964 2.964 0 1 0 0 5.929A2.964 2.964 0 0 0 12 4.5M7.536 7.464a4.464 4.464 0 1 1 8.928 0 4.464 4.464 0 0 1-8.928 0M12 15.071a7.514 7.514 0 0 0-7.274 5.632.75.75 0 1 1-1.452-.373c1-3.886 4.527-6.759 8.726-6.759s7.726 2.873 8.726 6.759a.75.75 0 1 1-1.452.373A7.514 7.514 0 0 0 12 15.071" clip-rule="evenodd"/></svg>';
export {
  e as w
};
